import {
  ColorDTO,
  colorDtoToHex,
  colorDtoToLabel,
} from '@model/dynamicTimeTable/ColorDTO';
import { Box, Typography } from '@mui/material';
import React from 'react';

const brightnessOf = (color: ColorDTO): number =>
  Number.parseInt(colorDtoToHex(color).slice(1), 16);

// Ordered from lightest to darkest (White ... Black), instead of the
// declaration order of the ColorDTO enum, which isn't a usable shade order.
export const SORTED_COLOR_DTOS: ColorDTO[] = [...Object.values(ColorDTO)].sort(
  (a, b) => brightnessOf(b) - brightnessOf(a),
);

export const EINK_SWATCH_COLORS = SORTED_COLOR_DTOS.map((color) => ({
  value: colorDtoToHex(color),
  label: colorDtoToLabel(color),
}));

export const UNSET_COLOR_VALUE = '';

export const translateColorLabel = (
  rawLabel: string,
  t: (key: string, options?: Record<string, unknown>) => string,
): string => {
  if (rawLabel === 'White') {
    return t('announcement-editor.color.white');
  }
  if (rawLabel === 'Black') {
    return t('announcement-editor.color.black');
  }
  const level = rawLabel.replace(/gray$/, '');
  return t('announcement-editor.color.gray', { level });
};

export const ColorSwatch = ({ color }: { color: string }) => (
  <Box
    sx={{
      width: 16,
      height: 16,
      borderRadius: 0.5,
      border: '1px solid',
      borderColor: 'divider',
      backgroundColor: color || 'transparent',
    }}
  />
);

export const ColorSelectValue = ({ label, color }: { label: string; color: string }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    <Typography variant='caption' sx={{ fontWeight: 700, lineHeight: 1 }}>
      {label}
    </Typography>
    <ColorSwatch color={color} />
  </Box>
);
